export default "__VITE_ASSET__BE4ds1NS__"